// import Maps from './maps.component'
import Maps from './mapsgoogle.component'

export default Maps
